import React, { useState, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import _ from 'lodash';
import { connect } from 'react-redux';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import withForm from 'modules/common/hoc/withForm';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import SecuredImage from 'modules/common/components/SecuredImage';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import PropTypes from 'prop-types';
import moment from 'moment';
import ReactToPrint from 'react-to-print';
import ViewImage from '../../components/ViewImage';
import * as actions from '../../action';
import * as c from '../../constant';

class ComponentToPrint extends React.Component {
  render() {
    const { src, rotation, heightWidth } = this.props;

    return (
      <>
        <SecuredImage
          onContextMenu={(e) => {
            e.preventDefault();
            return false;
          }}
          alt="BC"
          src={src}
          style={{ transform: ` rotate(${rotation}deg)`, width: `${heightWidth}`, height: `${heightWidth}` }}
        />
      </>
      // <embed src={src} title="BC Photo" />
    );
  }
}

ComponentToPrint.propTypes = {
  src: PropTypes.string.isRequired,
  rotation: PropTypes.number.isRequired,
  heightWidth: PropTypes.string.isRequired
};

function SearchContainer({
  getBirthcertificatesArchive,
  birthcertificatesArchiveList,
  isCheckingArchive,
  isLoadingPhoto,
  permissions,
}) {
  const [searchBy, setSearchBy] = useState('DETAILS');
  const [rotation, setRotation] = useState(0);
  const [heightWidth, setHeightWidth] = useState('auto');
  // eslint-disable-next-line no-unused-vars
  const [imgData, setImgData] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [imgSide, setImgSide] = useState('');
  const toPrintContenRef = useRef();
  const [imgSrc, setImgSrc] = useState('');
  const [isSearch, setIsSearch] = useState(0);
  const [formData, setFormData] = useState({});

  const onChangeInput = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeSelect = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const handleOnChangeDate = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value !== false ? value : '',
    });
  };

  const handleGetPhoto = (data, side) => e => {
    e.preventDefault();
    setImgData(data);

    setImgSide(side);
    if (side === 'front') {
      setImgSrc(_.get(data, 'front_page'));
    }
    if (side === 'back') {
      setImgSrc(_.get(data, 'back_page'));
    }
  };

  const onBack = e => {
    e.preventDefault();
    setImgSrc('');
  };

  const getTr = item => {
    let listImages = [];
    listImages = item.images;
    return listImages.map((birthDetail, index) => (
      <tr
        // eslint-disable-next-line react/no-array-index-key
        key={`${_.get(item, 'id')}+${index}`}
        className="border-top"
      >
        <td>{`${_.get(item, 'registry_number')} `}</td>
        <td>
          {`${_.get(item, 'first_name')}
          ${_.get(item, 'middle_name') || ''}
          ${_.get(item, 'last_name')}`.toUpperCase()}
        </td>
        <td>
          {`${_.get(item, 'mothers_first_name')}
          ${_.get(item, 'mothers_middle_name') || ''}
          ${_.get(item, 'mothers_last_name')}`.toUpperCase()}
        </td>
        <td>{`${moment(_.get(item, 'birth_date')).format('YYYY-MM-DD')}`}</td>
        <td style={{ textAlign: 'right' }}>
          <ViewImage
            item={birthDetail}
            isLoading={isLoadingPhoto}
            handleGetPhoto={handleGetPhoto}
          />
        </td>
      </tr>
    ));
  };

  const onRotateLeft = (e) => {
    e.preventDefault();
    let newRotation = rotation - 90;
    if (newRotation === -360) {
      newRotation = 0;
      setRotation(newRotation)
    }

    const rotationArray = [-90, 270, 90, -270];

    if (rotationArray.includes(newRotation)) {
      setHeightWidth('700px')
    } else {
      setHeightWidth('auto')
    }

    setRotation(newRotation);
  };

  const onRotateRight = (e) => {
    e.preventDefault();
    let newRotation = rotation + 90;
    if (newRotation === 360) {
      newRotation = 0;
      setRotation(newRotation)
    }

    const rotationArray = [90, 270, -90, -270];

    if (rotationArray.includes(newRotation)) {
      setHeightWidth('700px')
    } else {
      setHeightWidth('auto')
    }

    setRotation(newRotation);
  };

  const handleOnSubmit = e => {
    e.preventDefault();
    const combine = { ...formData, search_by: searchBy };
    getBirthcertificatesArchive(
      {
        ..._.pick(
          {
            ...combine,
          },
          _.keys(c.FORM_DATA)
        ),
      },
      () => {
        setIsSearch(1);
      }
    );
  };

  const onClear = e => {
    e.preventDefault();
    setFormData({
      first_name: '',
      last_name: '',
      middle_name: '',
      mothers_last_name: '',
      mothers_middle_name: '',
      mothers_first_name: '',
      extension_name: '',
    });
    setIsSearch(0);
  };

  const handleSearch = val => e => {
    e.preventDefault();
    setSearchBy(val);
    setFormData({
      search_by: val,
    });
    setIsSearch(0);
  };

  const onClearRegistryNumber = e => {
    e.preventDefault();
    setFormData({
      registration_number: '',
    });
    setIsSearch(0);
  };

  return (
    <div className="mt-3">
      <div className="">
        <div className="d-flex mb-3">
          <button
            type="submit"
            onClick={handleSearch('REGISTRY_NUMBER')}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            Search by Registry Number
          </button>
          <button
            type="submit"
            onClick={handleSearch('DETAILS')}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary "
          >
            Search by Fields
          </button>
        </div>
      </div>
      {searchBy === 'REGISTRY_NUMBER' && (
        <form
          className="border border-primary p-3 rounded-2"
          onSubmit={handleOnSubmit}
        >
          <div className="row ">
            <div className="col-4 form-group">
              <label>
                Registry Number <span className="text-danger">*</span>
              </label>
              <input
                required
                value={_.get(formData, 'registry_number') || ''}
                onChange={onChangeInput}
                name="registry_number"
                type="text"
                className="form-control"
                placeholder="Registry Number"
                aria-describedby="basic-addon2"
              />
            </div>
          </div>

          <div className="d-flex justify-content-center">
            <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3">
              <span className="font-weight-bold">Search</span>
            </button>
            <button
              type="button"
              onClick={onClearRegistryNumber}
              className="mt-3 btn btn-warning mr-3"
            >
              <span className="font-weight-bold">Clear</span>
            </button>
          </div>
        </form>
      )}
      {searchBy === 'DETAILS' && (
        <form
          className="border border-primary p-3 rounded-2"
          onSubmit={handleOnSubmit}
        >
          <div>
            <div className="row ">
              <div className="col-2 form-group">
                <label>
                  First Name <span className="text-danger">*</span>
                </label>
                <input
                  required
                  onChange={onChangeInput}
                  value={_.get(formData, 'first_name') || ''}
                  name="first_name"
                  type="text"
                  className="form-control"
                  placeholder="First Name"
                  aria-label="first name"
                  aria-describedby="basic-addon2"
                />
              </div>
              <div className="col-2 form-group">
                <label>Middle Name</label>
                <input
                  onChange={onChangeInput}
                  value={_.get(formData, 'middle_name') || ''}
                  name="middle_name"
                  type="text"
                  className="form-control"
                  placeholder="Middle name"
                  aria-label="middle_name"
                  aria-describedby="basic-addon2"
                />
              </div>
              <div className="col-2 form-group">
                <label>
                  Last Name <span className="text-danger">*</span>
                </label>
                <input
                  required
                  onChange={onChangeInput}
                  value={_.get(formData, 'last_name') || ''}
                  name="last_name"
                  type="text"
                  className="form-control"
                  placeholder="Last Name"
                  aria-label="last_name"
                  aria-describedby="basic-addon2"
                />
              </div>
              <div className="col-2 form-group">
                <label>Extension Name</label>
                <Select
                  name="extension_name"
                  placeholder="Select Extension Name"
                  onChange={handleChangeSelect('extension_name')}
                  options={c.EXTENSION_NAMES}
                  value={{
                    value: formData.extension_name,
                    label: formData.extension_name,
                  }}
                />
              </div>
              <div className="col-3 form-group">
                <label>Birth Date</label>
                <DateInputPicker
                  className="full-input"
                  onChange={handleOnChangeDate('birth_date')}
                  value={_.get(formData, 'birth_date') || ''}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-3 form-group">
                <label>Mother&apos;s First Name </label>
                <input
                  onChange={onChangeInput}
                  value={_.get(formData, 'mothers_first_name') || ''}
                  name="mothers_first_name"
                  type="text"
                  className="form-control"
                  placeholder="Mothers First Name"
                  aria-label="mothers_first_name"
                  aria-describedby="basic-addon2"
                />
              </div>
              <div className="col-3 form-group">
                <label>Mother&apos;s Middle Name</label>
                <input
                  onChange={onChangeInput}
                  value={_.get(formData, 'mothers_middle_name') || ''}
                  name="mothers_middle_name"
                  type="text"
                  className="form-control"
                  placeholder="Mothers Middle Name"
                  aria-label="mothers_middle_name"
                  aria-describedby="basic-addon2"
                />
              </div>
              <div className="col-3 form-group">
                <label>Mother&apos;s Maiden Last Name </label>
                <input
                  onChange={onChangeInput}
                  value={_.get(formData, 'mothers_last_name') || ''}
                  name="mothers_last_name"
                  type="text"
                  className="form-control"
                  placeholder="Mothers Last Name"
                  aria-label="mothers_last_name"
                  aria-describedby="basic-addon2"
                />
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center">
            <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3">
              <span className="font-weight-bold">Search</span>
            </button>
            <button
              type="button"
              onClick={onClear}
              className="mt-3 btn btn-warning mr-3"
            >
              <span className="font-weight-bold">Clear</span>
            </button>
          </div>
        </form>
      )}
      {isCheckingArchive && (
        <div className="loading">
          <div className="spinner text-center">
            <span className="fas fa-1x fa-spin fa-spinner" />
          </div>
        </div>
      )}
      {isSearch === 1 && birthcertificatesArchiveList.length !== 0 && (
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12 mt-3">
                {imgSrc === '' && (
                  <table className="table table-borderless table-striped table-sm table-condensed">
                    <thead>
                      <tr>
                        <th scope="col">Registry Number</th>
                        <th scope="col">Name</th>
                        <th scope="col">Mothers Maiden Name</th>
                        <th scope="col">Birth Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {birthcertificatesArchiveList.map(item => getTr(item))}
                    </tbody>
                  </table>
                )}
                {imgSrc !== '' && (
                  <>
                    <button
                      type="button"
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary btn-md"
                      onClick={onBack}
                    >
                      <i className="fa fa-arrow-left" />
                      &nbsp;BACK
                    </button>
                    &nbsp;
                    {Acl(permissions, [
                      'PRINT IN SEARCH BIRTH CERTIFICATE',
                    ]) &&
                      (
                        <ReactToPrint
                          trigger={() => (
                            <button
                              type="button"
                              className="btn btn-primary cms-bg-color-primary cms-outline-primary btn-md"
                            >
                              <i className="fa fa-print" />
                              &nbsp;PRINT
                            </button>
                          )}
                          content={() => toPrintContenRef.current}
                        />
                      )}
                    &nbsp;
                    <button
                      type="button"
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-md"
                      onClick={onRotateLeft}
                    >
                      <i className="fa fa-arrow-left" />
                      &nbsp;ROTATE LEFT
                    </button>
                    &nbsp;
                    <button
                      type="button"
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-md"
                      onClick={onRotateRight}
                    >
                      ROTATE RIGHT&nbsp;
                      <i className="fa fa-arrow-right" />
                    </button>
                    &nbsp;
                    <hr />
                    <div className="d-flex justify-content-center align-items-center">
                      <ComponentToPrint
                        rotation={rotation}
                        src={imgSrc}
                        ref={toPrintContenRef}
                        heightWidth={heightWidth}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {!isCheckingArchive && birthcertificatesArchiveList.length === 0 && (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> Birth Certificate not found </p>
          </div>
        </div>
      )}
    </div>
  );
}

SearchContainer.propTypes = {
  birthcertificatesArchiveList: PropTypes.instanceOf(Array).isRequired,
  getBirthcertificatesArchive: PropTypes.instanceOf(Function).isRequired,
  isCheckingArchive: PropTypes.instanceOf(Function).isRequired,
  isLoadingPhoto: PropTypes.bool.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  birthcertificatesArchiveList: _.get(api, `${c.GET_BIRTH_ARCHIVE}.list`) || [],
  isLoading: api.loading.indexOf(c.GET_BIRTH_ARCHIVE) > -1,
  isCheckingArchive: api.loading.indexOf(c.GET_BIRTH_ARCHIVE) > -1,
  isLoadingPhoto: api.loading.indexOf(c.GET_PHOTO) > -1,
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(SearchContainer);
